import { Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Sidebar } from "@/components/layout/Sidebar";
import { TopBar } from "@/components/layout/TopBar";

export function AppLayout() {
  const { pathname } = useLocation();
  const hideTopBar = pathname === "/";
  return (
    <div className="flex h-screen w-full overflow-hidden jv-grid text-slate-200">
      <div className="pointer-events-none fixed inset-0 jv-grid-lines opacity-60" />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "rgba(10,15,29,0.95)",
            border: "1px solid rgba(0,240,255,0.3)",
            color: "#e2e8f0",
            fontFamily: "JetBrains Mono, monospace",
            fontSize: "12px",
          },
        }}
      />
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0 relative z-10">
        {!hideTopBar && <TopBar />}
        <main className="flex-1 min-h-0 overflow-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
